<template>
<div class="online-paydetail paydetail">
  <div class="nav-bar">
    <i
      @click="goDepositHandle"
      class="el-icon-back icon-btn pointer"></i>
    <span
      @click="goDepositHandle"
      class="pointer">{{currentChannel.channelName}}</span>
  </div>
  <div class="pay-detail">
    <div
      v-if="currentChannel.desc"
      class="tips-card">
      <div class="subtitle">{{$t('Precautions')}}</div>
      <div class="tips-p ql-container"
           v-html="currentChannel.desc"
      ></div>
    </div>
    <div class="content-card">
      <div class="account-list-top-text">{{$t('deposit_account')}}</div>
      <mtaccount-list
          ref="mtlist"
      ></mtaccount-list>
      <!--otc购币payType == 10的才需要上传手持身份证照片-->
      <el-row
        class="secondform-row"
        v-if="currentChannel.payPlatformName == 'OTC365-CoinPay' && reason.handleCertIdentifyStatus != 3"
      >
        <el-col
          :lg="8"
          :sm="8"
          :xs="24"
        >
          <el-form
            v-if="reason.handleCertIdentifyStatus != 3"
            class="secondform"
            ref="secondform"
            :model="secondForm"
            :rules="secondRules"
            label-position="top"
          >
            <el-form-item
              :label="$t('Holding_ID_photo')"
              prop="handleCertImgUrl"
            >
              <upload-img-tips></upload-img-tips>
              <div>
                <MobileImageUpload
                  :value="secondForm.handleCertImgUrl"
                  @input="(url) => { secondForm.handleCertImgUrl = url }"
                  @success="(url) => { secondForm.handleCertImgUrl = url }"
                >
                  <img v-if="secondForm.handleCertImgUrl" :src="secondForm.handleCertImgUrl" class="avatar">
                  <div v-else class="avatar-uploader-btn">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                  </div>
                </MobileImageUpload>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="nav-title">{{$t('Payment_currency')}}</div>
      <div
        class="tab-inner">
        <div class="tab-item"
             v-for="(item,index) in currencyList"
             :key="index"
             :class="{on: item == currency }"
             :style="getActiveStyle(item)"
             @click="currencyHandle(item)"
        >
          {{item}}
        </div>
      </div>
      <el-row>
        <el-col
          :lg="8"
          :sm="8"
          :xs="24"
        >
          <el-form
            class="elform"
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
          <el-form-item
              v-if="currentChannel.payPlatformName == 'Exlink-VND'"
              prop="newChannelType"
              :label="$t('Channel_Type')"
            >
              <el-select
                :placeholder="$t('root.selectPls')"
                v-model="form.newChannelType"
                @change = "getTheBankType"
                style="width: 100%"
              >
                <el-option
                  v-for="(item,index) in channelTypeOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          <el-form-item
              v-if="currentChannel.payPlatformName == 'Exlink-VND'"
              prop = 'bankCode'
              :label="$t('payment_bank')"
            >
              <el-select
                :placeholder="$t('root.selectPls')"
                v-model="form.bankCode"
                filterable
                popper-append-to-body = "true"
                :disabled = "notSelectableInLoading"
                style="width: 100%;"
                popper-class = "customoption"
              >
                <el-option
                  v-for="(item,index) in banklist"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
              </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="currentChannel.payPlatformName == 'SulifuPay'"
              prop="channelType"
              :label="$t('Channel_Type')"
            >
              <el-select
                :placeholder="$t('root.selectPls')"
                v-model="form.channelType"
                style="width: 100%"
              >
                <el-option
                  v-for="(item,index) in typeOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="currentChannel.payPlatformName == 'SulifuPay' && form.channelType == 'SupermarketCodePay'"
              prop="markeCode"
              :label="$t('Supermarket_Code')"
            >
              <el-select
                :placeholder="$t('root.selectPls')"
                v-model="form.markeCode"
                style="width: 100%"
              >
                <el-option
                  v-for="(item,index) in supermarketCode"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="currentChannel.payPlatformName == 'SulifuPay' && form.channelType == 'BankToBank'"
              prop="bankCode"
              :label="$t('Bank_Code')"
            >
              <el-select
                :placeholder="$t('root.selectPls')"
                v-model="form.bankCode"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item,index) in backCode"
                  :key="index"
                  :label="getLabel(item)"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="currentChannel.payPlatformName == 'SulifuPay' && form.channelType != 'SupermarketCodePay'"
              prop="playerPayAcc"
              :label="$t('Player_Account')"
            >
              <el-input
                :placeholder="$t('please_enter')"
                v-model.number="form.playerPayAcc"
                @input="payAccInput"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="currentChannel.payPlatformName == 'OfaPay-IDR-OB'"
              prop="bankCode"
              :label="$t('Bank_Code')"
            >
              <el-select
                :placeholder="$t('root.selectPls')"
                v-model="form.bankCode"
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item,index) in idrOBBankList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="currentChannel.payPlatformName == 'OfaPay-IDR-VA'"
              prop="bankCode"
              :label="$t('Bank_Code')"
            >
              <el-select
                :placeholder="$t('root.selectPls')"
                v-model="form.bankCode"
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item,index) in idrVABankList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('Amount_deposited')"
              prop="curentLimitMoney"
              class="has-prefix-item"
            >
              <el-input
                :placeholder="amountTips"
                :value="form.curentLimitMoney"
                @blur="curentMoneyBlurHandle"
                @input="inputHandle"
              >
                <span slot="prefix">USD</span>
              </el-input>
              <p>{{$t('User.fee')}}: ${{ fee }}</p>
            </el-form-item>
            <el-form-item
              :label="$t('Trade.payMoney')"
              prop="totalAmount"
              class="has-prefix-item"
            >
              <el-input
                disabled
                :value="getTotalSum"
              >
                <span slot="prefix">{{ currency }}</span>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                :loading="submitLoading"
                @click="payHandle"
              >{{$t('confirm_payment')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
  <sure-dialog
    ref="suredialog"
    :dialog-show="dialogShow"
    @formsubmit="confirmHanlde"
    @close="closeDialog"
    :online-pay-info="onlinePayInfo"
  >
    <perfect-money-form
      :perfectmoney-info="onlinePayInfo"
      @formsubmit="confirmHanlde"
    ></perfect-money-form>
  </sure-dialog>
</div>
</template>

<script>
import { limitInt } from '@/utils/validate'
import perfectMoneyForm from "@/components/deposit/perfectMoneyForm";
import { getVerifiedInfo } from '@/api/user';
import mtaccountList from "@/components/public/mtaccountList";
import { colorRgba } from "@/utils";
import {
  LeverWithdraw,
  LeverWithdrawVer,
  EnterMoeny,
  getUSDExRateAndFee
} from '@/api/userCenter.js';
import { getDictListByType } from "@/api/home";
import { mapGetters } from 'vuex'
import { onlyTwoBitFloat,amountInputValidate } from '@/utils/validate';
export default {
  name: "index",
  components: {
    mtaccountList,
    perfectMoneyForm,
  },
  data() {
    let _this = this;
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('payChannel.inputMoney')));
      }else {
        if(!onlyTwoBitFloat(value)){
          callback(new Error(this.$t('User.onlyInputTwoBitNumber')));
          this.$emit('request-err');
          return;
        }else {
          callback();
        }
      }
    };
    return {
      currency: '',
      onlinePayList: [],
      // 表单
      form: {
        curentLimitMoney: '',

        channelType: 'SupermarketCodePay',//Sulifu
        newChannelType:'vndDirectBankList',
        banklist:[],
        markeCode: '',//Sulifu
        bankCode: '',//Sulifu
        playerPayAcc: '',//Sulifu

      },
      notSelectableInLoading:false,
      rules: {
        curentLimitMoney: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
        markeCode: [
          { required: true, message:  _this.$t('please_choose'),trigger: 'change' }
        ],//Sulifu
        bankCode: [
          { required: true, message:  _this.$t('please_input'),trigger: 'change' }
        ],//Sulifu
        playerPayAcc: [
          { required: true, message:  _this.$t('please_input'),trigger: 'blur' }
        ],//Sulifu
        channelType:[
          { required: true, message:  _this.$t('please_input'),trigger: 'blur' }
        ],
        newChannelType:[
          { required: true, message:  _this.$t('please_input'),trigger: 'blur' }
        ],
      },
      dialogShow: false,
      currencyType: 1, // 固定等于1,
      exchangeRate: '', // 美元兑人民币实时汇率
      onlinePayInfo: {
        amount: '',
        fee: '',
        currency: '',
        totalAmount: '',
      },
      //sulifu
      supermarketCode: [
        {label: 'IBON',},
        {label: 'HI-Life',},
        {label: 'OK',},
        {label: 'FamiPort',},
      ],
      typeOption: [
        {label: _this.$t('Card_punch'),value: 'BankToBank'},
        {label: _this.$t('Convenience_store_code_payment'),value: 'SupermarketCodePay'},
      ],
      channelTypeOption: [
        {label: _this.$t('direct_bank_connection'),value: 'vndDirectBankList'},
        {label: _this.$t('scan_the_code_for_online_banking'),value: 'vndQrCodeBankList'},
      ],
      backCode: [
        {value: 'dp_391',	label: '一卡通',labelEn: 'All-in-one card'},
        {value: 'dp_568',	label: '七股區農會',labelEn: 'Qigu District Farmers\' Association'},
        {value: 'dp_147',	label: '三信銀行',labelEn: 'Sanxin Bank'},
        {value: 'dp_599',	label: '三星地區農會',labelEn: 'Samsung District Farmers Association'},
        {value: 'dp_925',	label: '三灣鄉農會',labelEn: 'Sanwan Township Farmers Association'},
        {value: 'dp_919',	label: '三義鄉農會',labelEn: 'Sanyi Township Farmers\' Association'},
        {value: 'dp_011',	label: '上海銀行',labelEn: 'Shanghai Bank'},
        {value: 'dp_549',	label: '下營區農會',labelEn: 'Xiaying District Farmers Association'},
        {value: 'dp_822',	label: '中國信託',labelEn: 'China Trust'},
        {velue: 'dp_954',	label: '中埔鄉農會',labelEn: 'Zhongpu Township Farmers Association'},
        {value: 'dp_575',	label: '中寮鄉農會',labelEn: 'Zhongliao Township Farmers\' Association'},
        {value: 'dp_602',	label: '中華民國農會',labelEn: 'Peasants\' Association of the Republic of China'},
        {value: 'dp_700',	label: '中華郵政',labelEn: 'Chunghwa Post'},
        {value: 'dp_643',	label: '二水鄉農會',labelEn: 'Ershui Township Farmers\' Association'},
        {value: 'dp_596',	label: '五結鄉農會',labelEn: 'Wujie Township Farmers\' Association'},
        {value: 'dp_054',	label: '京城銀行',labelEn: 'Beijing Bank'},
        {value: 'dp_562',	label: '仁德區農會',labelEn: 'Rende District Farmers Association'},
        {value: 'dp_582',	label: '仁愛鄉農會',labelEn: 'Ren\'ai Township Farmers\' Association'},
        {value: 'dp_636',	label: '伸港鄉農會',labelEn: 'Shengang Township Farmers\' Association'},
        {value: 'dp_581',	label:'信義鄉農會',labelEn: 'Xinyi Township Farmers Association'},
        {value: 'dp_806',	label: '元大銀行',labelEn: 'Yuanta Bank'},
        {value: 'dp_697',	label: '元長農會',labelEn: 'Yuanchang Farmers\' Association'},
        {value: 'dp_017',	label: '兆豐銀行',labelEn: 'Mega Bank'},
        {value: 'dp_898',	label: '光豐地區農會',labelEn: '光豐地區農會'},
        {value: 'dp_749',	label: '內埔地區農會',labelEn: 'Neipu District Farmers Association'},
        {value: 'dp_986',	label: '內湖區農會',labelEn: 'Neipu District Farmers Association'},
        {value: 'dp_769',	label: '八德本會',labelEn: 'Bade Association'},
        {value: 'dp_917',	label: '公館鄉農會',labelEn: 'Gongguan Township Farmers Association'},
        {value: 'dp_912',	label: '冬山農會',labelEn: 'Dongshan Farmers Association'},
        {value: 'dp_809',	label: '凱基銀行',labelEn: 'KGI Bank'},
        {value: 'dp_936',	label: '北埔鄉農會',labelEn: 'Beipu Township Farmers Association'},
        {value: 'dp_984',	label: '北投農本會',labelEn: 'Beitou Agricultural Association'},
        {value: 'dp_633',	label: '北斗鎮農會',labelEn: 'Beidou Town Farmers Association'},
        {value: 'dp_683',	label: '北港鎮農會',labelEn: 'Beigang Town Farmers Association'},
        {value: 'dp_914',	label: '卓蘭鎮農會',labelEn: 'Zhuolan Town Farmers Association'},
        {value: 'dp_567',	label: '南化區農會',labelEn: 'Nanhua District Farmers Association'},
        {value: 'dp_517',	label: '南市區漁會',labelEn: 'Nanshi District Fishermen\'s Association'},
        {value: 'dp_921',	label: '南庄鄉農會',labelEn: 'Nanzhuang Township Farmers Association'},
        {value: 'dp_570',	label: '南投市農會',labelEn: 'Nantou City Farmers Association'},
        {value: 'dp_987',	label: '南港區農會',labelEn: 'Nangang District Farmers Association'},
        {value: 'dp_518',	label: '南縣漁會',labelEn: 'Nan County Fisheries Association'},
        {value: 'dp_997',	label: '南資中心',labelEn: 'South Capital Center'},
        {value: 'dp_952',	label: '南農中心',labelEn: 'Nannong Center'},
        {value: 'dp_510',	label: '南龍區漁會',labelEn: 'Nanlong District Fisheries Association'},
        {value: 'dp_329',	label: '印尼商印尼人民銀行台北分行',labelEn: 'Indonesian Commercial Bank of Indonesia, Taipei Branch'},
        {value: 'dp_146',	label: '台中二信',labelEn: 'Taichung Second Letter'},
        {value: 'dp_625',	label: '台中市農會',labelEn: 'Taichung City Farmers Association'},
        {value: 'dp_053',	label: '台中銀行',labelEn: 'Taichung Bank'},
        {value: 'dp_104',	label: '台北五信',labelEn: 'Taipei Five Letters'},
        {value: 'dp_188',	label: '台南三信',labelEn: 'Tainan Sanxin'},
        {value: 'dp_618',	label: '台南市農會',labelEn: 'Tainan Farmers\' Association'},
        {value: 'dp_812',	label: '台新銀行',labelEn: 'Taishin Bank'},
        {value: 'dp_622',	label: '台東地區農會',labelEn: 'Taitung Area Farmers Association'},
        {value: 'dp_006',	label: '合作金庫銀行',labelEn: 'Cooperative Treasury Bank'},
        {value: 'dp_961',	label: '同袍儲蓄會',labelEn: 'Tongpao Savings Association'},
        {value: 'dp_613',	label: '名間農會',labelEn: 'Famous Farmers\' Association'},
        {value: 'dp_886',	label: '和平區農會',labelEn: 'Heping District Farmers Association'},
        {value: 'dp_629',	label: '和美鎮農會',labelEn: 'Hemei Town Farmers Association'},
        {value: 'dp_589',	label: '員山鄉農會',labelEn: 'Yuanshan Township Farmers\' Association'},
        {value: 'dp_178',	label: '嘉義三信',labelEn: 'Chiayi Sanxin'},
        {value: 'dp_617',	label: '嘉義地區農會',labelEn: 'Chiayi District Farmers Association'},
        {value: 'dp_515',	label: '嘉義漁會',labelEn: 'Chiayi Fishermen\'s Association'},
        {value: 'dp_579',	label: '國姓鄉農會',labelEn: 'Guoxing Township Farmers Association'},
        {value: 'dp_013',	label: '國泰世華銀行',labelEn: 'Cathay Pacific Bank'},
        {value: 'dp_394',	label: '國際連',labelEn: 'international company'},
        {value: 'dp_005',	label: '土地銀行',labelEn: 'land bank'},
        {value: 'dp_775',	label: '土城區農會',labelEn: 'Tucheng District Farmers\' Association'},
        {value: 'dp_685',	label: '土庫鎮農會',labelEn: 'Tuku Town Farmers Association'},
        {value: 'dp_573',	label: '埔里鎮農會',labelEn: 'Puli Town Farmers Association'},
        {value: 'dp_649',	label: '埔鹽鄉農會',labelEn: 'Puyan Township Farmers Association'},
        {value: 'dp_114',	label: '基隆一信',labelEn: 'A letter from Keelung'},
        {value: 'dp_115',	label: '基隆二信',labelEn: 'Keelung Second Letter'},
        {value: 'dp_516',	label: '基隆區漁會',labelEn: 'Keelung District Fisheries Association'},
        {value: 'dp_615',	label: '基隆農會',labelEn: 'Keelung Farmers Association'},
        {value: 'dp_985',	label: '士農',labelEn: 'scholar farmer'},
        {value: 'dp_588',	label: '壯圍鄉農會',labelEn: 'Zhuangwei Township Farmers\' Association'},
        {value: 'dp_883',	label: '外埔區農會',labelEn: 'Waipu District Farmers Association'},
        {value: 'dp_552',	label: '大內區農會',labelEn: 'Ouchi District Farmers\' Association'},
        {value: 'dp_766',	label: '大園區農會',labelEn: 'Dayuan District Farmers Association'},
        {value: 'dp_646',	label: '大城鄉農會',labelEn: 'Dacheng and Rural Farmers\' Association'},
        {value: 'dp_884',	label: '大安區農會',labelEn: 'Da\'an District Farmers\' Association'},
        {value: 'dp_639',	label: '大村鄉農會',labelEn: 'Dacun Township Farmers Association'},
        {value: 'dp_926',	label: '大湖地區農會',labelEn: 'Great Lakes Region Farmers Association'},
        {value: 'dp_762',	label: '大溪本會',labelEn: 'Daxi Association'},
        {value: 'dp_814',	label: '大眾銀行',labelEn: 'public bank'},
        {value: 'dp_882',	label: '大肚區農會',labelEn: 'Dadu District Farmers Association'},
        {value: 'dp_901',	label: '大里農會',labelEn: 'Dali Farmers\' Association'},
        {value: 'dp_556',	label: '學甲區農會',labelEn: 'Xuejia District Farmers Association'},
        {value: 'dp_558',	label: '安定區農會',labelEn: 'Anding District Farmers Association'},
        {value: 'dp_816',	label: '安泰銀行',labelEn: 'Aetna Bank'},
        {value: 'dp_551',	label: '官田區農會',labelEn: 'Guantian District Farmers Association'},
        {value: 'dp_124',	label: '宜蘭信合社',labelEn: 'Yilan Xinheshe'},
        {value: 'dp_538',	label: '宜蘭市農會',labelEn: 'Yilan City Farmers Association'},
        {value: 'dp_607',	label: '宜蘭農會',labelEn: 'Yilan Farmers Association'},
        {value: 'dp_012',	label: '富邦銀行',labelEn: 'Fubon Bank'},
        {value: 'dp_934',	label: '寶山鄉農會',labelEn: 'Baoshan Township Farmers Association'},
        {value: 'dp_823',	label: '將來商業銀行',labelEn: 'future commercial bank'},
        {value: 'dp_620',	label: '屏東市農會',labelEn: 'Pingtung City Farmers Association'},
        {value: 'dp_559',	label: '山上區農會',labelEn: 'Shan District Farmers Association'},
        {value: 'dp_935',	label: '峨眉鄉農會',labelEn: 'Emei Township Farmers\' Association'},
        {value: 'dp_561',	label: '左鎮區農會',labelEn: 'Zuozhen District Farmers\' Association'},
        {value: 'dp_082',	label: '巴黎銀行',labelEn: 'bank paris'},
        {value: 'dp_764',	label: '平鎮區農會',labelEn: 'Pingzhen District Farmers Association'},
        {value: 'dp_158',	label: '彰化一信',labelEn: 'Changhua Yixin'},
        {value: 'dp_161',	label: '彰化五信',labelEn: 'Changhua Five Letters'},
        {value: 'dp_162',	label: '彰化六信',labelEn: 'Changhua Liuxin'},
        {value: 'dp_511',	label: '彰化區漁會',labelEn: 'Changhua District Fisheries Association'},
        {value: 'dp_163',	label: '彰化十信',labelEn: 'Changhua Ten Faiths'},
        {value: 'dp_614',	label: '彰化地區農會',labelEn: 'Changhua District Farmers Association'},
        {value: 'dp_651',	label: '彰化市農會',labelEn: 'Changhua Farmers Association'},
        {value: 'dp_009',	label: '彰化銀行',labelEn: 'Changhua Bank'},
        {value: 'dp_547',	label: '後壁區農會',labelEn: 'Houbi District Farmers Association'},
        {value: 'dp_913',	label: '後龍鎮農會',labelEn: 'Houlong Town Farmers Association'},
        {value: 'dp_772',	label: '復興本會',labelEn: 'Revitalize our association'},
        {value: 'dp_072',	label: '德意志銀行',labelEn: 'Deutsche Bank'},
        {value: 'dp_390',	label: '悠遊付',labelEn: 'Youyou pay'},
        {value: 'dp_392',	label: '愛金卡',labelEn: 'Aijin Card'},
        {value: 'dp_103',	label: '新光銀行',labelEn: 'Shin Kong Bank'},
        {value: 'dp_519',	label: '新化區農會',labelEn: 'Xinhua District Farmers Association'},
        {value: 'dp_606',	label: '新北市地區農會',labelEn: 'New Taipei City District Farmers Association'},
        {value: 'dp_930',	label: '新埔鎮農會',labelEn: 'Xinpu Town Farmers Association'},
        {value: 'dp_770',	label: '新屋區農會',labelEn: 'Xinwu District Farmers Association'},
        {value: 'dp_557',	label: '新市區農會',labelEn: 'Xinshi District Farmers Association'},
        {value: 'dp_524',	label: '新港漁會',labelEn: 'Xingang Fishermen\'s Association'},
        {value: 'dp_881',	label: '新社區農會',labelEn: 'New Community Farmers Association'},
        {value: 'dp_130',	label: '新竹一信',labelEn: 'Hsinchu Yixin'},
        {value: 'dp_132',	label: '新竹三信',labelEn: 'Hsinchu Sanxin'},
        {value: 'dp_507',	label: '新竹區漁會',labelEn: 'Hsinchu District Fishermen\'s Association'},
        {value: 'dp_940',	label: '新竹農信用部',labelEn: 'Hsinchu Agricultural Credit Department'},
        {value: 'dp_904',	label: '新莊農會',labelEn: 'Xinzhuang Farmers Association'},
        {value: 'dp_939',	label: '新豐鄉農會',labelEn: 'Xinfeng Township Farmers Association'},
        {value: 'dp_815',	label: '日盛銀行',labelEn: 'Risheng Bank'},
        {value: 'dp_810',	label: '星展銀行',labelEn: 'DBS Bank'},
        {value: 'dp_989',	label: '景美區農會',labelEn: 'Jingmei District Farmers Association'},
        {value: 'dp_988',	label: '木柵農會',labelEn: 'Muzha Farmers Association'},
        {value: 'dp_075',	label: '東亞銀行',labelEn: 'Bank of East Asia'},
        {value: 'dp_693', label: 	'東勢鄉農會',labelEn: 'Dongshi Township Farmers Association'},
        {value: 'dp_583',	label: '東山農會',labelEn: 'dongshan farmers association'},
        {value: 'dp_523',	label: '東港漁會',labelEn: 'Donggang Fishermen\'s Association'},
        {value: 'dp_118',	label: '板信銀行',labelEn: 'Banxin Bank'},
        {value: 'dp_928',	label: '板橋農會',labelEn: 'Banqiao Farmers Association'},
        {value: 'dp_699',	label: '林內鄉農會',labelEn: 'Linnei Township Farmers Association'},
        {value: 'dp_127',	label:'桃園信合社',labelEn: 'Taoyuan Credit Union'},
        {value: 'dp_506',	label: '桃園區漁會',labelEn: 'Taoyuan District Fishermen’s Association'},
        {value: 'dp_763',	label: '桃農本會',labelEn: 'Peach Farmers Association'},
        {value: 'dp_521',	label: '梓官區漁會',labelEn: 'Ziguan District Fishermen\'s Association'},
        {value: 'dp_765',	label: '楊梅區農會',labelEn: 'Yangmei District Farmers Association'},
        {value: 'dp_826',	label: '樂天銀行',labelEn: 'Rakuten Bank'},
        {value: 'dp_395',	label: '橘子支付',labelEn: 'Orange Pay'},
        {value: 'dp_938',	label: '橫山地區農會',labelEn: 'Hengshan District Farmers Association'},
        {value: 'dp_397',label: '歐付寶',labelEn: 'Oufubao'},
        {value: 'dp_696',	label: '水林鄉農會',labelEn: 'Shuilin Township Farmers Association'},
        {value: 'dp_578',	label: '水里鄉農會',labelEn: 'Shuili Township Farmers\' Association'},
        {value: 'dp_807',	label: '永豐銀行',labelEn: 'Wing Fung Bank'},
        {value: 'dp_903',	label: '汐止區農會',labelEn: 'Xizhi District Farmers Association'},
        {value: 'dp_023',	label: '泰國盤谷銀行',labelEn: 'Bangkok Bank of Thailand'},
        {value: 'dp_119',	label: '淡水一信',labelEn: 'Tamsui Yixin'},
        {value: 'dp_120',	label: '淡水信合社',labelEn: 'Tamsui Credit Union'},
        {value: 'dp_052',	label: '渣打銀行',labelEn: 'Standard Chartered Bank'},
        {value: 'dp_932',	label: '湖口鄉農會',labelEn: 'Hukou Township Farmers Association'},
        {valeu: 'dp_647',	label: '溪州鄉農會',labelEn: 'Xizhou Township Farmers\' Association'},
        {value: 'dp_631',	label: '溪湖鎮農會',labelEn: 'Xihu Town Farmers Association'},
        {value: 'dp_081',	label: '滙豐銀行',labelEn: 'HSBC'},
        {value: 'dp_879',	label: '潭子區農會',labelEn: 'Tanzi District Farmers Association'},
        {value: 'dp_222',	label: '澎湖一信',labelEn: 'Penghu Yixin'},
        {value: 'dp_223',	label: '澎湖二信',labelEn: 'Penghu Second Letter'},
        {value: 'dp_525',	label: '澎湖區漁會',labelEn: 'Penghu District Fisheries Association'},
        {value: 'dp_624',	label: '澎湖農會',labelEn: 'Penghu Farmers Association'},
        {value: 'dp_039',	label: '澳商澳盛銀行',labelEn: 'Australian Commercial Bank'},
        {value: 'dp_876',	label: '烏日區農會',labelEn: 'Wuri District Farmers Association'},
        {value: 'dp_923',	label: '獅潭鄉農會',labelEn: 'Shitan Township Farmers Association'},
        {value: 'dp_808',	label: '玉山銀行',labelEn: 'Yushan Bank'},
        {value: 'dp_896',	label: '玉溪地區農會',labelEn: 'Yuxi District Farmers Association'},
        {value: 'dp_048',	label: '王道銀行',labelEn: 'King Road Bank'},
        {value: 'dp_895',	label: '瑞穗鄉農會',labelEn: 'Ruisui Township Farmers Association'},
        {value: 'dp_020',	label: '瑞穗銀行',labelEn: 'Mizuho Bank'},
        {value: 'dp_101',	label: '瑞興銀行',labelEn: 'Ruixing Bank'},
        {value: 'dp_513',	label: '瑞芳區漁會',labelEn: 'Ruifang District Fisheries Association'},
        {value: 'dp_632',	label: '田中鎮農會',labelEn: 'Tianzhong Town Farmers Association'},
        {value: 'dp_953',	label: '田尾鄉農會',labelEn: 'Tianwei Township Farmers Association'},
        {value: 'dp_541',	label: '白河區農會',labelEn: 'Baihe District Farmers Association'},
        {value: 'dp_880',	label: '石岡區農會',labelEn: 'Shigang District Farmers Association'},
        {value: 'dp_587',	label: '礁溪鄉農會',labelEn: 'Jiaoxi Township Farmers\' Association'},
        {value: 'dp_642',	label: '社頭鄉農會',labelEn: 'Shetou Township Farmers\' Association'},
        {value: 'dp_612',	label: '神岡豐原農會',labelEn: 'Kamioka Toyobara Farmers\' Association'},
        {value: 'dp_650',	label: '福興鄉農會',labelEn: 'Fuxing Township Farmers\' Association'},
        {value: 'dp_931',	label: '竹北市農會',labelEn: 'Zhubei Farmers Association'},
        {value: 'dp_907',	label: '竹南鎮農會',labelEn: 'Zhunan Town Farmers Association'},
        {value: 'dp_574',	label: '竹山鎮農會',labelEn: 'Zhushan Town Farmers Association'},
        {value: 'dp_937',	label: '竹東地區農會',labelEn: 'Zhudong District Farmers Association'},
        {value: 'dp_007',	label: '第一銀行',labelEn: 'first bank'},
        {value: 'dp_398',	label: '簡單付',labelEn: 'Pay simply'},
        {value: 'dp_635',	label: '線西鄉農會',labelEn: 'Xianxixiang Farmers Association'},
        {value: 'dp_586',	label: '羅東鎮農會',labelEn: 'Luodong Town Farmers Association'},
        {value: 'dp_022',	label: '美國銀行',labelEn: 'Bank of America'},
        {value: 'dp_910',	label: '聯資中心',labelEn: 'Joint Venture Center'},
        {value: 'dp_803',	label: '聯邦銀行',labelEn: 'Commonwealth Bank'},
        {value: 'dp_803ENT',label: '聯邦銀行公司戶',labelEn: 'Commonwealth Bank Corporate Account'},
        {value: 'dp_922',	label: '臺南農信用',labelEn: 'Tainan Rural Credit Union'},
        {value: 'dp_050',	label: '臺灣中小企業銀行',labelEn: 'aiwan Small and Medium Enterprises Bank'},
        {value: 'dp_004',	label: '臺灣銀行',labelEn: 'bank of taiwan'},
        {value: 'dp_933',	label: '芎林鄉農會',labelEn: 'Xionglin Township Farmers Association'},
        {value: 'dp_638',	label: '花壇鄉農會',labelEn: 'Huatan Township Farmers Association'},
        {value: 'dp_021',	label: '花旗銀行',labelEn: 'Citibank'},
        {value: 'dp_215',	label: '花蓮一信',labelEn: 'A letter from Hualien'},
        {value: 'dp_216',	label: '花蓮二信',labelEn: 'Hualien Second Letter'},
        {value: 'dp_891',	label: '花蓮市農會',labelEn: 'Hualien City Farmers Association'},
        {value: 'dp_621',	label: '花蓮縣農會',labelEn: 'Hualien County Farmers Association'},
        {value: 'dp_909',	label: '苑裡鎮農會',labelEn: 'Yuanli Town Farmers Association'},
        {value: 'dp_902',	label: '苗栗市農會',labelEn: 'Miaoli City Farmers Association'},
        {value: 'dp_916',	label: '草屯農會',labelEn: 'Caotun Farmers Association'},
        {value: 'dp_008',	label: '華南銀行',labelEn: 'South China Bank'},
        {value: 'dp_102',	label: '華泰銀行',labelEn: 'Huatai Bank'},
        {value: 'dp_514',	label: '萬里區漁會',labelEn: 'Wanli District Fisheries Association'},
        {value: 'dp_767',	label: '蘆竹區農會',labelEn: 'Luzhu District Farmers Association'},
        {value: 'dp_501',	label: '蘇澳區漁會',labelEn: 'Suao District Fisheries Association'},
        {value: 'dp_598',	label: '蘇澳地區農會',labelEn: 'Suao District Farmers Association'},
        {value: 'dp_396',	label: '街口支付',labelEn: 'Pay on the street'},
        {value: 'dp_915',	label: '西湖鄉農會',labelEn: 'Xihu Township Farmers Association'},
        {value: 'dp_018',	label: '農業金庫',labelEn: 'agricultural treasury'},
        {value: 'dp_600',	label: '農金資中心',labelEn: 'Agricultural Finance Center'},
        {value: 'dp_508',	label: '通苑區漁會',labelEn: 'Tongyuan District Fishermen’s Association'},
        {value: 'dp_908',	label: '通霄鎮農會',labelEn: 'Tongxiao Town Farmers Association'},
        {value: 'dp_920',	label: '造橋鄉農會',labelEn: 'Zaoqiao Township Farmers\' Association'},
        {value: 'dp_627',	label: '連江縣農會',labelEn: 'Lianjiang County Farmers\' Association'},
        {value: 'dp_824',	label: '連線商業銀行',labelEn: 'online commercial bank'},
        {value: 'dp_805',	label: '遠東銀行',labelEn: 'far east bank'},
        {value: 'dp_224',	label: '金門信合社',labelEn: 'Kinmen Credit Union'},
        {value: 'dp_526',	label: '金門區漁會',labelEn: 'Kinmen District Fishermen’s Association'},
        {value: 'dp_918',	label: '銅鑼鄉農會',labelEn: 'Tongluo Township Farmers Association'},
        {value: 'dp_564',	label: '關廟區農會',labelEn: 'Guanmiao District Farmers Association'},
        {value: 'dp_929',	label: '關西鎮農會',labelEn: 'Guanxi Town Farmers Association'},
        {value: 'dp_108',	label: '陽信銀行',labelEn: 'Yangxin Bank'},
        {value: 'dp_512',	label: '雲林漁會',labelEn: 'Yunlin Fishermen\'s Association'},
        {value: 'dp_616',	label: '雲林縣農會',labelEn: 'Yunlin County Farmers Association'},
        {value: 'dp_874',	label: '霧峰區農會',labelEn: 'Wufeng District Farmers Association'},
        {value: 'dp_330',	label: '韓亞銀行',labelEn: 'Hana Bank'},
        {value: 'dp_906',	label: '頭份市農會',labelEn: 'Toufen Farmers\' Association'},
        {value: 'dp_502',	label: '頭城區漁會',labelEn: 'Toucheng District Fishermen\'s Association'},
        {value: 'dp_585',	label: '頭城鎮農會',labelEn: 'Toucheng Town Farmers\' Association'},
        {value: 'dp_924',	label: '頭屋鄉農會',labelEn: 'Touwu Township Farmers Association'},
        {value: 'dp_025',	label: '首都銀行',labelEn: 'metropolitan bank'},
        {value: 'dp_204',	label: '高雄三信',labelEn: 'Kaohsiung Sanxin'},
        {value: 'dp_520',	label: '高雄區漁會',labelEn: 'Kaohsiung District Fishermen\'s Association'},
        {value: 'dp_605',	label: '高雄市農會',labelEn: 'Kaohsiung City Farmers Association'},
        {value: 'dp_016',	label: '高雄銀行',labelEn: 'kaohsiung bank'},
        {value: 'dp_577',	label: '魚池鄉農會',labelEn: 'Yuchi Township Farmers Association'},
        {value: 'dp_897',	label: '鳳榮地區農會',labelEn: 'Fengrong District Farmers Association'},
        {value: 'dp_780',	label: '鶯歌區農會',labelEn: 'Yingge District Farmers Association'},
        {value: 'dp_165',	label: '鹿港信合社',labelEn: 'Lukang Credit Union'},
        {value: 'dp_628',	label: '鹿港鎮農會',labelEn: 'Lukang Town Farmers Association'},
        {value: 'dp_580',	label: '鹿谷鄉農會',labelEn: 'Lugu Township Farmers Association'},
        {value: 'dp_698',	label: '麥寮鄉農會',labelEn: 'Mailiao Township Farmers\' Association'},
        {value: 'dp_542',	label: '麻豆區農會',labelEn: 'Madou District Farmers Association'},
        {value: 'dp_885',	label: '龍井區農會',labelEn: 'Longjing District Farmers\' Association'},
        {value: 'dp_565',	label: '龍崎區農會',labelEn: 'Longqi District Farmers Association'},
        {value: 'dp_771', label: '龍潭區農會',labelEn: 'Longtan District Farmers Association'},
        {value: 'dp_768',	label: '龜山區農會',labelEn: 'Guishan District Farmers\' Association'},
      ],
      // otc买币,没有传过手持身份证照片的需要上传,
      secondForm: {
        handleCertImgUrl: '',
      },
      secondRules: {
        handleCertImgUrl: [
          { required: true, message: _this.$t('Please_upload_a_photo_of_holding_your_ID_card'), trigger: 'change' },
        ]
      },
      reason:{
        handleCertIdentifyStatus: ''
      },
      submitLoading: false,
      idrOBBankList: [],
      idrVABankList: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile','themeColor','language']),
    computedTips(){
      if(this.$route.query.payType == 1){
        return this.$t('depositBankTips');
      }else {
        return this.$t('depositUsdtTips');
      }
    },
    currentChannel(){
      let defaultChannel = {
        availableTime:"",
        channelCode:"",
        channelName:"",
        channelType:1,
        currency:"",
        feeType:1,
        feeValue:0.025,
        isSelect:true,
        limitation:"",
        nominalExRateDeposit:7.1275,
        nominalExRateWithdraw:6.8659,
        oprType:1,
        picType:1,
        realExRateDeposit:7.0395,
        realExRateWithdraw:7.0098,
        sign:""
      };
      for (let i = 0; i < this.onlinePayList.length; i++) {
        if(this.onlinePayList[i].channelCode == this.$route.params.channelCode){
          defaultChannel = this.onlinePayList[i];
          break;
        }
      }
      return defaultChannel;
    },
    rate(){
      return this.currentChannel.nominalExRateDeposit;
    },
    currencyList(){
      let  currentArr = this.currentChannel.currency.split(',');
      return currentArr;
    },
    // 没算手续费的总额,
    getTotalSum(){
      if(this.form.curentLimitMoney == '' || !Number(this.form.curentLimitMoney)){
        return `0`;
      }
      // 选择USD
      if(this.currentChannel.payPlatformName === 'bft' || this.currentChannel.payPlatformName === 'uEnjoy' || this.currentChannel.payPlatformName === 'BipiPay'){
        return Math.ceil(this.form.curentLimitMoney * this.exchangeRate);
      }else {
        if(this.currency == 'CNY' || this.currency == 'VND' || this.currency == 'TWD' || this.currency == 'IDR'){
          // 人民币渠道的都默认向上取整
          return Math.ceil(this.form.curentLimitMoney * this.exchangeRate);
        }else {
          return  (this.form.curentLimitMoney * this.exchangeRate).toFixed(2);
        }
      }
    },

    amountTips(){
      let minLimit = '';
      if(this.currency.includes('CNY')||this.currency.includes('VND')||this.currency.includes('TWD')||this.currency.includes('IDR')){
        minLimit = Math.ceil(this.currentChannel.minimumLimit / this.exchangeRate);
      }else {
        minLimit = this.currentChannel.minimumLimit;
      }
      return `≥${minLimit}`
    },
    //手续费
    fee(){
      // 保留两位小数
      let feeTotal = (this.currentChannel.feeValue * this.form.curentLimitMoney).toFixed(2);
      return feeTotal;
    },

  },
  created(){
    this.getChannelList();
    this.getTheBankType();
  },
  mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    getList() {
      getVerifiedInfo({
        custId: this.userInfo.id,
      }).then((res) => {
        this.reason = res.data;
      })
    },
    inputHandle(val){
      this.form.curentLimitMoney = amountInputValidate(val);
    },
    curentMoneyBlurHandle(){
      this.queryExchangeRate();
    },
    //根据通道类型 获取银行类型
    getTheBankType(){
      this.notSelectableInLoading = true;
      getDictListByType({type: this.form.newChannelType}).then((res) => {
        this.form.bankCode = "";
        this.banklist = res.data;
        this.$nextTick(()=>{
          this.notSelectableInLoading = false;
        })
      });
    },
    getIdrBankList(type, listKey){
      getDictListByType({type: type}).then((res) => {
        this[listKey] = res.data;
      });
    },
    getChannelList(){
      getUSDExRateAndFee({
        oprType: 1,
        payType: +this.$route.query.payType,
      }).then((res) => {
        this.onlinePayList = res.data;
        this.currency = this.currencyList[0];
        this.queryExchangeRate();
        //OTC365需要查询手持身份证照片的状态
        if(this.currentChannel.payPlatformName == 'OTC365-CoinPay'){
          // 查询手持身份证照状态
          this.getList();
        }
        // OfaPay-IDR 获取银行列表
        if(this.currentChannel.payPlatformName == 'OfaPay-IDR-OB'){
          this.getIdrBankList('idrOBBankList', 'idrOBBankList');
        }
        if(this.currentChannel.payPlatformName == 'OfaPay-IDR-VA'){
          this.getIdrBankList('idrVABankList', 'idrVABankList');
        }
      })
    },
    getLabel(item){
      if(this.language == 'zh_CN' || this.language == 'zh_Hant'){
        return item.label;
      }else if(this.language == 'en_US'){
        return item.labelEn;
      }
    },
    queryExchangeRate(){
      let params = {
        oprType: 1,
        payType: this.$route.query.payType,
        channelCode: this.$route.params.channelCode,
      }
      if(this.form.curentLimitMoney){
        let finalAmount = (this.form.curentLimitMoney + '');
        let finalBillAmount = (((this.form.curentLimitMoney * this.rate).toFixed(2)) + '');
        params.amount = finalAmount;
        params.billAmount = finalBillAmount;
      }
      getUSDExRateAndFee(params).then((res) => {

        if(res.data.length){
          this.exchangeRate = res.data[0].nominalExRateDeposit;
        }
      })
    },

    getActiveStyle(item){
      if(item == this.currency){
        return {
          backgroundColor: colorRgba(this.themeColor,0.1),
        }
      }
    },
    payAccInput(value){
      this.form.playerPayAcc =  limitInt(value);
    },
    currencyHandle(item){
      this.currency = item;
    },
    payHandle(item){
      if(this.currentChannel.payPlatformName != 'OTC365-CoinPay'){
        this.$refs.form.validate((valid) => {
          if(valid){
            //  本地汇款：确认支付跳转第三方页面，本页面变成【提交成功】
            this.enterGolden();
          }
        })
      }else {
        this.$refs.form.validate((valid) => {
          if(valid){
            if(this.reason.handleCertIdentifyStatus != 3){
              this.$refs.secondform.validate((secondValid) => {
                if(secondValid){
                  //  otc购币
                  this.otcEnterGolden();
                }
              })
            }else {
              //  otc购币
              this.otcEnterGolden();
            }
          }
        })
      }
    },
    closeDialog(){
      this.dialogShow = false;
    },
    confirmHanlde(){
      this.dialogShow = false;
      this.$router.push({name: 'successSubmit'}).catch(() => {
        window.location.href = this.$router.resolve({name: 'successSubmit'}).href;
      });
    },
    enterGolden(){
      if(!this.$refs.mtlist.curLogin){
        return;
      }
      if(!this.form.curentLimitMoney){
        return;
      }
      // 先查询汇率接口在调入金接口
      let finalAmount = (this.form.curentLimitMoney + '') ;
      let finalBillAmount = (((this.form.curentLimitMoney * this.rate).toFixed(2)) + '');
      this.submitLoading = true;
      getUSDExRateAndFee({
        oprType: 1,
        payType: +this.$route.query.payType,
        channelCode: this.currentChannel.channelCode,
        amount: finalAmount,
        billAmount: finalBillAmount,
      }).then((res) => {
        this.exchangeRate = res.data[0].nominalExRateDeposit;
        let realTimeRealExRateDeposit = res.data[0].realExRateDeposit;
        let mtlist = this.$refs.mtlist;
        let parmas = {
          custId: this.userInfo.id,
          serverId: mtlist.currentMt4Info.serverId,
          login: mtlist.currentMt4Info.login,
          group: mtlist.currentMt4Info.group,
          currency: this.currentChannel.currency ,
          payType: this.currentChannel.channelCode,
          realExRate: realTimeRealExRateDeposit,
          nominalExRate: this.exchangeRate,
          type: 1
        };
        if(this.currencyType == 1){
          parmas.amount = this.form.curentLimitMoney + '';
          if(this.currentChannel.payPlatformName === 'bft' || this.currentChannel.payPlatformName === 'uEnjoy' || this.currentChannel.payPlatformName === 'BipiPay' || this.currentChannel.payPlatformName == 'SulifuPay' || this.currentChannel.payPlatformName == 'Exlink-VND'){
            parmas.billAmount = (Math.ceil(this.form.curentLimitMoney * this.exchangeRate)) + '';
          }else {
            if(this.currency == 'CNY' || this.currency == 'VND' || this.currency == 'TWD' || this.currency == 'IDR'){
              // 人民币渠道的都默认取整
              parmas.billAmount = Math.ceil(this.form.curentLimitMoney * this.exchangeRate) + '';
            }else {
              parmas.billAmount = (this.form.curentLimitMoney * this.exchangeRate).toFixed(2) + '';
            }
          }
        }else {
          parmas.amount = ((this.form.curentLimitMoney / this.exchangeRate).toFixed(2)) + '';
          parmas.billAmount = this.form.curentLimitMoney + '';
        }
        if(this.currentChannel.payPlatformName == 'SulifuPay'){
          // IBON,Hi-Life,OK, FamiPort
          parmas.channelType = this.form.channelType;
          if(this.form.channelType == 'SupermarketCodePay'){
            parmas.supermarketCode = this.form.markeCode;

          }else if(this.form.channelType == 'BankToBank'){
            parmas.bankCode = this.form.bankCode;
            parmas.playerPayAcc = this.form.playerPayAcc;
          }
        }
        if(this.currentChannel.payPlatformName == 'Exlink-VND'){
            parmas.bankCode = this.form.bankCode;
            if(this.form.newChannelType == 'vndDirectBankList'){
                parmas.channelType = 'BankDirect';
            }
            if(this.form.newChannelType == 'vndQrCodeBankList'){
                parmas.channelType = 'ScanQRCode';
            }
        }
        if(this.currentChannel.payPlatformName == 'OfaPay-IDR-OB' || this.currentChannel.payPlatformName == 'OfaPay-IDR-VA'){
            parmas.bankCode = this.form.bankCode;
        }
        EnterMoeny(parmas).then((res) => {
          this.submitLoading = false;
          this.onlinePayInfo = res.data;
          this.onlinePayInfo.fee = this.fee;
          this.onlinePayInfo.totalAmount = this.getTotalSum;
          this.dialogShow = true;
        }).catch((err) => {
          this.submitLoading = false;
        })
      })
    },
    otcEnterGolden(){
      // 未测试 todo
      let mtlist = this.$refs.mtlist;
      let parmas = {
        custId: this.userInfo.id,
        serverId: mtlist.currentMt4Info.serverId,
        login: mtlist.currentMt4Info.login,
        group: mtlist.currentMt4Info.group,
        amount: (this.form.curentLimitMoney / this.currentChannel.nominalExRateDeposit).toFixed(2),
        billAmount: this.form.curentLimitMoney,
        currency:  'USDT',
        payType: this.currentChannel.channelCode,
        realExRate: this.currentChannel.realExRateDeposit,
        nominalExRate: this.currentChannel.nominalExRateDeposit,
        type: 1,
        handleCertImg: this.secondForm.handleCertImgUrl,
      };
      this.submitLoading = true;
      EnterMoeny(parmas).then((res) => {
        this.submitLoading = false;
        this.onlinePayInfo = res.data;
        this.onlinePayInfo.fee = this.fee;
        this.onlinePayInfo.totalAmount = this.getTotalSum;
        this.dialogShow = true;
      }).catch((err) => {
        this.submitLoading = false;
        this.$emit('request-err');
      })
    },
    goDepositHandle(){
      this.$router.push({name: 'depositFunds'});
    },
  },
}
</script>

<style lang="scss" scoped>
.online-paydetail {
  .nav-bar {

    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    .icon-btn {
      font-size: 16px;
    }
  }
  .pay-detail {
    padding: 24px;
    .tips-card,
    .content-card {
      background-color: #ffffff;
      border-radius: 10px;
      margin-bottom: 24px;
      padding: 24px;
      .has-prefix-item {
        /deep/ .el-input__inner {
          padding-left: 60px;
        }
        /deep/ .el-input__prefix {
          left: 16px
        }
      }
    }

    .nav-title {
      margin-bottom: 15px;
      margin-top: 15px;
    }
  }
  .secondform-row {
    margin-top: 30px;
  }
}
// 移动端样式
@media screen and (max-width: 768px){
  .customoption{
    .el-select-dropdown__item{
      max-width: 300px;
      white-space: normal;
      word-wrap: break-word;
      height: auto;
      line-height: 20px;
      margin-bottom: 8px;
    }
  }
}
</style>
